import styled from "styled-components";
import MemoContractSearch from "@local/icons/component/ContractSearch"
import { Autocomplete, Chip } from "@ui-library/core";
import { colors, colorPalette } from "_shared/styles/color";
import { SkeletonLoaderDiv } from "_shared/styles/skeletonLoader";

export const Container = styled(SkeletonLoaderDiv)`
    display: inline-flex;
    position: relative;
    ${props => props.isLoading && `
        top: 21px;
        position: relative;
        height: 45px;
        margin-left: 25px;
    `}
`;

export const ContractSearchIcon = styled(MemoContractSearch)`
  height: 20px;
  width: 20px;
  margin-top: 3px;
  z-index: 9999;
`;

export const StyledAutoComplete = styled(Autocomplete)`
    min-width: 335px;

    input:disabled {
        background-color: white;
        border: 1px solid ${colors.C15};
    }

    #contract-id {
        font-size: 16px;
        margin: 0;
    }

    .market-details  {
        font-size: 14px;
        color: #707070;
        margin : 0;
    }

    div[data-testid="gsl.uilib.Icon"] {
        margin-bottom: 40px;
    }

    div[data-testid="gsl.uilib.Icon"] {
        margin-bottom: 40px;
    }

    input[data-testid="gsl.uilib.TextField.input"] {
        padding: 0 40px
    }

    div[data-testid="gsl.uilib.Droplist"] {
        z-index: 2;
    }
`;

export const StyledChip = styled(Chip)`
    width: max-content;
    height: 28px;
    background-color: ${colorPalette.saphir};
    color: white;
    &:hover {
        background-color: ${colorPalette.saphir};
        color: white;
    }

    &:before {
        background-color: white;
    }
`;	

export const ChipIconElements = styled.div`
    display: inline-flex;
    position: absolute;
    margin-left: 13px;
    top: 32px;
    gap: 10px;
    z-index: 3;
`;